/* 
Componente cabezera, aparece en dispositivos mobiles.
Es un enrutado para las diferentes paginas
 */

import React from "react";
import clsx from "clsx";
import { withRouter } from "react-router-dom";

//I18N
import LangSelector from "../i18n/LangSelector";

//REDUX
import { useDispatch } from "react-redux";
import { logoutAction } from "../redux/actions/userActions";

//CONSTANT
import { HREF } from "../constants";

//CSS
import { makeStyles, useTheme } from "@material-ui/core/styles";
import Drawer from "@material-ui/core/Drawer";
import CssBaseline from "@material-ui/core/CssBaseline";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import ChevronRightIcon from "@material-ui/icons/ChevronRight";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import Box from "@material-ui/core/Box";
import ListItemText from "@material-ui/core/ListItemText";
//ICON
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import YouTubeIcon from "@material-ui/icons/YouTube";

const drawerWidth = 240;

const useStyles = makeStyles(theme => ({
  root: {
    display: "flex"
  },
  appBar: {
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  appBarShift: {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: drawerWidth,
    transition: theme.transitions.create(["margin", "width"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  menuButton: {
    marginRight: theme.spacing(2)
  },
  hide: {
    display: "none"
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0
  },
  drawerPaper: {
    width: drawerWidth
  },
  drawerHeader: {
    display: "flex",
    alignItems: "center",
    padding: theme.spacing(0, 1),
    ...theme.mixins.toolbar,
    justifyContent: "flex-end"
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    marginLeft: -drawerWidth,
    pointerEvents: "none"
  },
  contentShift: {
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen
    }),
    marginLeft: 0
  }
}));

function PersistentDrawerLeft({ history }) {
  const classes = useStyles();
  const theme = useTheme();
  const [open, setOpen] = React.useState(false);

  //#region DISPATCH & SELECTOR
  const dispatch = useDispatch();
  const logout = () => dispatch(logoutAction());
  //#endregion

  //#region Handle
  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };
  //#endregion

  //#region OnClick
  const onClickLogout = () => {
    logout()
      .then(() => {
        history.push("/login");
      })
      .catch(error => {
        console.log("error logout");
      });
  };

  //#endregion

  return (
    <div className={classes.root}>
      <CssBaseline />
      <AppBar
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: open
        })}
      >
        <Toolbar style={{ backgroundColor: "#363636" }}>
          <IconButton
            color="inherit"
            aria-label="open drawer"
            data-lang-attr="aria-label"
            data-lang-aria-label="menu_open"
            onClick={handleDrawerOpen}
            edge="start"
            className={clsx(classes.menuButton, open && classes.hide)}
          >
            <MenuIcon />
          </IconButton>
          <Box textAlign="center">
            <img
              alt="Logo"
              src={`${process.env.PUBLIC_URL}/assets/img/logo_V2.png`}
              title="Logo"
              className="pl-4"
              style={{height:"45px"}}
            />
          </Box>
          <Box ml="auto">
            <LangSelector />
          </Box>
        </Toolbar>
      </AppBar>
      <Drawer
        className={classes.drawer}
        variant="persistent"
        anchor="left"
        open={open}
        classes={{
          paper: classes.drawerPaper
        }}
      >
        <div className={classes.drawerHeader}>
          <IconButton onClick={handleDrawerClose}>
            {theme.direction === "ltr" ? (
              <ChevronLeftIcon />
            ) : (
              <ChevronRightIcon />
            )}
          </IconButton>
        </div>
        <Divider />
        <List>
          {HREF.map((value, index) => (
            <ListItem
              button
              key={index}
              onClick={() => {
                if (value.internal) {
                  history.push(value.url);
                } else {
                  window.open(value.url, "_blank");
                }
                setOpen(false);
              }}
            >
              <ListItemText
                primary={<span style={{ cursor: "pointer" }} data-lang={value.key}>{value.name}</span>}
              />
            </ListItem>
          ))}
        </List>
        <Divider />
        <List>
          {[
            {
              icon: (
                <FacebookIcon fontSize="small" style={{ color: "#3b5998" }} />
              ),
              href: "https://m.facebook.com/ilusionamaskebowling/"
            },
            {
              icon: (
                <InstagramIcon fontSize="small" style={{ color: "#C13584" }} />
              ),
              href: "https://www.instagram.com/ilusionamaskebowling/"
            },
            {
              icon: <YouTubeIcon fontSize="small" style={{ color: "red" }} />,
              href: "https://www.youtube.com/channel/UCXHpHJ78EBvZsjBNrU4VSfg/"
            }
          ].map((comp, index) => (
            <a
              target="_blank"
              rel="noopener noreferrer"
              href={comp.href}
              key={index}
            >
              <ListItem button>
                <ListItemIcon>{comp.icon}</ListItemIcon>
              </ListItem>
            </a>
          ))}
        </List>
        <Divider />
        <List>
          <ListItem button onClick={onClickLogout}>
            <Box my="auto">
              <span style={{ color: "blue", cursor: "pointer" }} data-lang="logout">
                Cerrar sesión
              </span>
            </Box>
          </ListItem>
        </List>
      </Drawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: open
        })}
        style={{ pointerEvents: "none" }}
      >
        <div className={classes.drawerHeader} />
      </main>
    </div>
  );
}

export default withRouter(PersistentDrawerLeft);
